export const EmployeeStatus = {
    Active: 'Active',
    Inactive: 'Inactive',
    Vacation: 'Vacation',
    Sick: 'Sick'
}

export const EmployeeStatusFR = {
    Active: 'Actif',
    Inactive: 'Inactif',
    Vacation: 'Vacance',
    Sick: 'Malade'
}

export const EmployeeStatusList = [EmployeeStatus.Active, EmployeeStatus.Inactive, EmployeeStatus.Sick, EmployeeStatus.Vacation]